





































































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import { mixins } from "vue-class-component";
import { formatCurrency } from "@/shared/currency.js";
import {
  DrivewealthHolding,
  InstrumentStatus,
  DrivewealthAccountSummary,
  DrivewealthAccountManagementType,
  InstrumentHolding
} from "@/shared/types";
import InstrumentName from "./InstrumentName.vue";
import _, { Dictionary } from "lodash";
import * as RouteNames from "@/employee/route-names";
import * as SharedRoutes from "@/shared/route-names";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useUserStore } from "@/shared/store/user";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { roundToTwoDecimals } from "@/shared/mathHelper";
import Pagination from "@/shared/components/ui/Pagination.vue";

@Component({
  components: {
    Pagination,
    InstrumentName,
    GenericLoadingSpinner
  }
})
export default class CurrentHoldingsTableV2 extends mixins(ErrorsMixin) {
  formatCurrency = formatCurrency;
  roundToTwoDecimals = roundToTwoDecimals;
  SharedRoutes = SharedRoutes;

  drivewealthStore = useDrivewealthStore();
  userStore = useUserStore();
  featureFlagStore = useFeatureFlagStore();

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: false })
  pageNumber: number;

  @Prop({ required: false })
  accountId: number;

  @Prop({ required: false })
  hideTrade: boolean;

  loadTable (): void {
    this.userStore.loadPartnerSettings();
    this.drivewealthStore.getAccountSummaryV2(
        { username: this.username, partnerId: this.partnerId, dwAccountId: this.accountId });
    this.drivewealthStore.loadAdvisoryFunds({ username: this.username, partnerId: this.partnerId });
  }

  @Watch("$props", { deep: true })
  reloadData (): void {
    this.loadTable();
  }

  mounted (): void {
    this.loadTable();
  }

  get accountSummaryV2 (): DrivewealthAccountSummary {
    return this.drivewealthStore.accountSummaryById(this.accountId);
  }

  routeParams (symbol: string): { symbol: string, accountId?: number, partnerId?: number } {
    if (this.accountId) {
      return { symbol, accountId: this.accountId, partnerId: this.partnerId };
    }

    return { symbol, partnerId: this.partnerId };
  }

  get accountSummaryV2RequestLoaded (): boolean {
    return this.drivewealthStore.accountSummaryV2Loaded(this.accountId);
  }

  get isLoaded (): boolean {
    return this.accountSummaryV2RequestLoaded &&
      this.drivewealthStore.advisoryFundsLoaded;
  }

  get pageCount (): number {
    return this.drivewealthStore.holdingsPageCount(this.accountId);
  }

  get holdingItemsGroupedByFundType (): Dictionary<InstrumentHolding[]> {
    const holdings = this.drivewealthStore.holdingsForPage(this.accountId, this.pageNumber);
    const groupedHoldings = _.groupBy(holdings, "fundType");
    return groupedHoldings;
  }

  onPageChanged (pageNumber: number) {
    const targetRoute: any = {
      name: this.$route.name,
      params: {accountId: this.accountId, pageNumber }
    };

    if (this.username) {
      targetRoute.query.username = this.username;
    }
    if (this.partnerId) {
      targetRoute.params.partnerId = this.partnerId;
    }

    this.$router.push(targetRoute);
  }

  canBuyThisInstrument (h: DrivewealthHolding): boolean {
    return h.status === InstrumentStatus.Active
      && (this.isSelfDirected || !!this.drivewealthStore.advisoryFundBySymbol(h.stockSymbol));
  }

  get buyRoute (): string {
    return RouteNames.DrivewealthBuyInstrumentV2;
  }

  get sellRoute (): string {
    return RouteNames.DrivewealthSellInstrumentV2;
  }

  isPositiveNumber (value: number): boolean {
    return value >= 0;
  }

  get isEmployerPortal (): boolean {
    return this.userStore.isEmployerPortal;
  }

  get employerPortalSellInstrumentEnabled (): boolean {
    return this.featureFlagStore.flags.bend23519EnablePartnerInvestmentInstrumentAllowSell &&
      this.isEmployerPortal;
  }

  get canBuySell (): boolean {
    return (this.employerPortalSellInstrumentEnabled || !this.username) &&
          !this.drivewealthStore.isAccountManagementType(DrivewealthAccountManagementType.RiaManaged, this.accountId) &&
          !this.userStore.partnerDisableInvestmentActivity;
  }

  get canBuySellPortfolio (): boolean {
    return (this.employerPortalSellInstrumentEnabled || !this.username) &&
          this.drivewealthStore.isAccountManagementType(DrivewealthAccountManagementType.RiaManaged, this.accountId) &&
          !this.userStore.partnerDisableInvestmentActivity;
  }

  get isSelfDirected (): boolean {
    return !this.username && this.drivewealthStore.isAccountManagementType(DrivewealthAccountManagementType.OpenBrokerage, this.accountId);
  }

  get hasPortfolio (): boolean {
    return this.accountSummaryV2RequestLoaded
      && this.accountSummaryV2.portfolioId !== null;
  }

  get isManagedAccount (): boolean {
    return this.drivewealthStore.isAccountManagementType(DrivewealthAccountManagementType.RiaManaged, this.accountId);
  }
}
